import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap gap-2 mb-7" }
const _hoisted_2 = { class: "text-fprimary m-0" }
const _hoisted_3 = { class: "fs-7 badge rounded-circle bg-navy" }
const _hoisted_4 = {
  key: 0,
  class: "row row-cols-2 row-cols-lg-4 g-5 g-xl-9 mb-6 mb-xl-9"
}
const _hoisted_5 = {
  key: 0,
  class: "col"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "card-body d-flex justify-content-center flex-column gap-4" }
const _hoisted_8 = { class: "symbol symbol-60px mb-3" }
const _hoisted_9 = {
  key: 0,
  class: "bi bi-building-check fs-2x text-navy bg-white p-2 rounded"
}
const _hoisted_10 = {
  key: 1,
  class: "bi bi-calculator-fill fs-2x text-navy bg-white p-2 rounded"
}
const _hoisted_11 = {
  key: 2,
  class: "bi bi-card-list fs-2x text-navy bg-white p-2 rounded"
}
const _hoisted_12 = {
  key: 3,
  class: "bi bi-person-check fs-2x text-navy bg-white p-2 rounded"
}
const _hoisted_13 = { class: "fs-4 fw-bold m-0" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "btn bg-white text-navy d-flex justify-content-between align-items-center" }, [
  /*#__PURE__*/_createTextVNode(" Completar "),
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right-short fs-2x text-navy p-0" })
], -1)
const _hoisted_16 = { class: "card-footer p-2 text-center" }
const _hoisted_17 = { class: "m-0" }
const _hoisted_18 = {
  key: 1,
  class: "col"
}
const _hoisted_19 = {
  class: "card h-100 border border-2 bg-navy bg-opacity-10",
  style: {"cursor":"not-allowed"}
}
const _hoisted_20 = { class: "card-body d-flex justify-content-center flex-column gap-4" }
const _hoisted_21 = { class: "symbol symbol-60px mb-3" }
const _hoisted_22 = {
  key: 0,
  class: "bi bi-building-check fs-2x text-navy bg-white p-2 rounded"
}
const _hoisted_23 = {
  key: 1,
  class: "bi bi-calculator-fill fs-2x text-navy bg-white p-2 rounded"
}
const _hoisted_24 = {
  key: 2,
  class: "bi bi-card-list fs-2x text-navy bg-white p-2 rounded"
}
const _hoisted_25 = {
  key: 3,
  class: "bi bi-person-check fs-2x text-navy bg-white p-2 rounded"
}
const _hoisted_26 = { class: "fs-4 fw-bold m-0 text-gray-500" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn bg-white text-start text-navy d-flex justify-content-between",
  style: {"cursor":"not-allowed"}
}, [
  /*#__PURE__*/_createTextVNode(" Completar "),
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right-short fs-2x text-navy p-0" })
], -1)
const _hoisted_29 = { class: "card-footer p-2 text-center" }
const _hoisted_30 = { class: "text-gray-400 m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_DrawerFormGeneral = _resolveComponent("DrawerFormGeneral")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t("forms")) + " " + _toDisplayString(_ctx.t("available")), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.listForms.length), 1)
    ]),
    (_ctx.listForms.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listForms, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: `fl-s-${index}`
            }, [
              (item.enabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["card h-100 border border-2 cursor-pointer border-white shadow border-hover bg-opacity-50", `${item.status != null ? 'bg-'+item?.status?.params : 'bg-navy'}`]),
                      onClick: ($event: any) => (_ctx.openDialogForm(item))
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          (item?.idform == 1)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                            : _createCommentVNode("", true),
                          (item?.idform == 2)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                            : _createCommentVNode("", true),
                          (item?.idform == 3)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                            : _createCommentVNode("", true),
                          (item?.idform == 4)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("h5", _hoisted_13, _toDisplayString(item.form_name), 1),
                        _createElementVNode("p", {
                          class: "fs-7 fw-normal m-0 fst-italic",
                          innerHTML: `${item.form_details}`
                        }, null, 8, _hoisted_14),
                        _hoisted_15
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.t('dateEnd')) + " " + _toDisplayString(_ctx.formatDate(item.end_date)), 1)
                      ])
                    ], 10, _hoisted_6)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          (item?.idform == 1)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_22))
                            : _createCommentVNode("", true),
                          (item?.idform == 2)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_23))
                            : _createCommentVNode("", true),
                          (item?.idform == 3)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_24))
                            : _createCommentVNode("", true),
                          (item?.idform == 4)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_25))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("h5", _hoisted_26, _toDisplayString(item.form_name), 1),
                        _createElementVNode("p", {
                          class: "fs-7 fw-normal m-0 fst-italic text-gray-400",
                          innerHTML: `${item.form_details}`
                        }, null, 8, _hoisted_27),
                        _hoisted_28
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.t('dateEnd')) + " " + _toDisplayString(_ctx.formatDate(item.end_date)), 1)
                      ])
                    ])
                  ]))
            ], 64))
          }), 128))
        ]))
      : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: `${_ctx.t('notFoundResult')}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.getForms
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('tryAgain')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["description"])), [
          [_directive_loading, _ctx.loader]
        ]),
    _createVNode(_component_DrawerFormGeneral, {
      ref: "DrawerFormGeneralRef",
      "id-event": _ctx.id,
      "item-form": _ctx.itemForm,
      onModalClosed: _ctx.modalClosed
    }, null, 8, ["id-event", "item-form", "onModalClosed"])
  ], 64))
}